const orig = console.error;
console.error = function() {
  let prefix = '[KaiOS-Store]';
  Array.prototype.unshift.call(arguments, prefix);
  orig.apply(console, arguments);
};
